export { useDeviceInfoContext } from "./DeviceInfoProvider";
export { default as DeviceInfoProvider } from "./DeviceInfoProvider";
